import { SansText } from '@velasca/ui/sans-text'
import { SansTitle } from '@velasca/ui/sans-title'
import { sanitizeHTML } from '@velasca/utils/sanitize-html'
import type { SizeGuideModalFooterProps } from './SizeGuideModalFooter.types'

export const SizeGuideModalFooter = ({
  title,
  text,
}: SizeGuideModalFooterProps): JSX.Element => {
  return (
    <>
      <SansTitle
        center
        as="h3"
        fontWeight="500"
        size="sm"
        margin="4rem 0 2.4rem 0"
        color="primary"
      >
        {title}
      </SansTitle>
      <SansText center as="div" dangerouslySetInnerHTML={sanitizeHTML(text)} />
    </>
  )
}
